import { useMutation } from '@tanstack/react-query';

import { queryClient } from '@hero/clients';
import { QUERY_KEYS } from '@hero/constants';
import { contactServices } from '@hero/services';

export const useUpdateContactsTags = options => {
  return useMutation(body => contactServices.updateContactTags(body), {
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetContactsKey] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetTagListKey] });
    }
  });
};
